module.exports = __webpack_public_path__ + "static/media/Moreton_Bay.12712157.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/council_logos/Moreton_Bay.jpg
// module id = 643
// module chunks = 0